import ColumnSet from '@/components/grid/columns/column-set';
import ColumnsDefinition from '@/common/definitions/columns/transactions';

export default new ColumnSet({
    id: 'transactions-list',
    ...ColumnsDefinition,
});
